import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, clearToken } from "../lib/auth";

/* Guards the admin routes.
 *
 * Checking that a token merely exists isn't enough: a token that expired
 * overnight still sits in localStorage, so the dashboard would render in full
 * and only fail once the user tried to save something. Expiry is checked here
 * and the stale token is cleared on the way out.
 *
 * This is convenience, not security — the API verifies every write itself. */
export default function ProtectedRoute({ children }) {
  const location = useLocation();

  if (!isTokenValid()) {
    clearToken();
    // `replace` keeps the guarded URL out of history, so Back doesn't bounce
    // the user between the login screen and a route they can't reach.
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }

  return children;
}
